import { render, staticRenderFns } from "./ClientIndicators.vue?vue&type=template&id=ca2dadb4"
import script from "./ClientIndicators.vue?vue&type=script&lang=js"
export * from "./ClientIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports